$(function () {
    $('#newsModal').on('show.bs.modal', function (event) {
        var button = $(event.relatedTarget);
        var name = button.data('name'),
            text = button.data('text'),
            img = button.data('img');
        var modal = $(this);
        //modal.find('.modal-title').text(name);
        //modal.find('.modal-img').html("<img src='" + img + "' class='img-fluid'/>");
        //modal.find('.modal-body').html(text);
    })
});